import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';

// ? I doubt we want to define an explicit type for this?
/**
 * Canadian Geospatial Platform logo SVG icon.
 *
 * @returns SVG element with Canada map graphic
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function GeoCaIcon(): any {
  return (
    <svg width="500" height="200" id="a" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="1100 0 1000 1010">
      <g>
        <path
          d="m492.3,73.3h-11.2c-1.3-16.9-8.8-32.5-21.2-44.1-12.5-11.6-28.7-18-45.8-18-5.3,0-10.6.6-15.7,1.8-.6-3.9-2.1-7.4-4.4-10.4,6.5-1.7,13.2-2.6,20-2.6,19.9,0,38.9,7.5,53.4,21,14.5,13.5,23.3,31.7,24.8,51.4l.1.9Z"
          fill="#005ea0"
        />
        <path d="m363.1,34.6c-9.4,10.8-15,24.3-16.1,38.7h-11.1v-.8c1.3-17.4,8.3-33.7,19.9-46.5,1.7,3.4,4.2,6.4,7.3,8.6Z" fill="#005ea0" />
        <path
          d="m391.9,16.3c0,8.7-7.1,15.8-15.8,15.8-3.1,0-5.9-.9-8.4-2.4-3.2-2-5.7-5.2-6.8-8.9-.4-1.4-.6-2.9-.6-4.5,0-8.7,7.1-15.8,15.8-15.8,4.2,0,8.1,1.7,10.9,4.4,2.7,2.6,4.5,6.2,4.9,10.1v1.3Z"
          fill="#005ea0"
        />
      </g>
      <path
        d="m422,156.5c10.9-1,21.5-4.4,31-9.8,14.1-8,25.2-20.1,32.2-34.7,3.9-8.3,6.4-17.3,7.2-26.6l.1-1.7h-11.1v.8c-.7,7.9-2.8,15.6-6.2,22.7,0,0,0,.1-.1.1-5.9,12.3-15.6,22.8-27.4,29.5l-.1.1c-4.6,2.6-9.4,4.6-14.4,6.1,0,0-.5.1-1,.2-.7.1-1.4.2-2.1.4-21.7,3.1-33.6-8.3-42.2-20-7.6-10.4-17.8-39.9-40.7-40h-11.2v.8c1.5,19.7,10.3,37.9,24.8,51.4,14.6,13.5,33.5,21,53.5,21h2.7c1.3,0,5-.3,5-.3Z"
        fill="#52c62a"
      />
    </svg>
  );
}

/**
 * Legend display SVG icon for layer legend panels.
 *
 * @param props - MUI SvgIcon properties
 * @returns SVG icon element
 */
export function LegendIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props}>
      <g transform="translate(-8.246 -7.922)">
        <rect width="5.961" height="5.961" transform="translate(10 16.942)" />
        <path d="M2.981,0,5.961,5.961H0Z" transform="translate(10 8)" />
        <line x2="10.059" transform="translate(20.432 10.608)" stroke="currentColor" strokeWidth="2" />
        <line x2="10.059" transform="translate(20.432 20.295)" stroke="currentColor" strokeWidth="2" />
        <line x2="10.059" transform="translate(20.432 29.237)" stroke="currentColor" strokeWidth="2" />
        <circle cx="2.981" cy="2.981" r="2.981" transform="translate(10 25.883)" />
      </g>
    </SvgIcon>
  );
}

/**
 * Clear highlight SVG icon with diagonal strikethrough.
 *
 * @param props - MUI SvgIcon properties
 * @returns SVG icon element
 */
export function ClearHighlightIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      {/* MUI Highlight icon path - highlighter marker (scaled down) */}
      <path d="m6 14 3 3v5h6v-5l3-3V9H6zm2-3h8v2.17l-3 3V20h-2v-3.83l-3-3zm3-9h2v3h-2zM3.502 5.874 4.916 4.46l2.122 2.12-1.414 1.415zm13.458.708 2.123-2.12 1.413 1.416-2.123 2.12z" />
      {/* Diagonal line */}
      <line x1="4" y1="4" x2="20" y2="20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
}
